// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__1DuH9","card":"Cards_card__19iLO","infected":"Cards_infected__SCP8u","recovered":"Cards_recovered__2PKFA","deaths":"Cards_deaths__2LzQi"};